(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/wallet-widget/assets/javascripts/wallet-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/wallet-widget/assets/javascripts/wallet-widget.js');
"use strict";


class WalletWidget extends HTMLElement {
  constructor() {
    super();
    const textEl = document.createElement('span');
    textEl.classList.add('js-wallet-text');
    textEl.innerHTML = 'Visa saldo';
    textEl.style.marginLeft = '8px';
    this.textEl = textEl;
    this.shouldShowBalance = false;
    svs.components.account_balance.on('change', balance => {
      if (this.shouldShowBalance) {
        this.textEl.innerHTML = "".concat(svs.utils.format.Currency(balance), " kr");
      }
    });
  }
  handleClick() {
    this.shouldShowBalance = !this.shouldShowBalance;
    if (!this.shouldShowBalance) {
      this.textEl.innerHTML = 'Visa saldo';
    } else {
      svs.components.account_balance.get(true, balance => {
        this.textEl.innerHTML = "".concat(svs.utils.format.Currency(balance), " kr");
      });
    }
  }
  connectedCallback() {
    const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    if (!isLoggedIn) {
      return;
    }
    const icon = Handlebars.partials['ui-icon-icon']({
      icon: 'balance',
      color: 'icon-inverted',
      size: 200
    });
    const wallet = document.createElement('div');
    wallet.style.color = 'white';
    wallet.style.cursor = 'pointer';
    wallet.style.padding = '8px';
    wallet.innerHTML = "".concat(icon);
    wallet.appendChild(this.textEl);
    this.addEventListener('click', this.handleClick);
    this.appendChild(wallet);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
}
customElements.define('wallet-widget', WalletWidget);

 })(window);